export var ForbiddenAction = function (handler) { return ({
    id: 'connect-other-account',
    text: 'Try another account',
    promise: function () { return new Promise(function (resolve) { return resolve(handler()); }); },
    buttonAppearance: 'primary',
}); };
//# sourceMappingURL=ForbiddenAction.js.map